<script>
	import Navbar from './Navbar.svelte';
	import Hero from './Hero.svelte';
	import About from './About.svelte';
	import WhyUs from './WhyUs.svelte';
	import Services from './Services.svelte';
	import Contacts from './Contacts.svelte';
	import Footer from './Footer.svelte';
	import Reviews from './Reviews.svelte';
	import Authors from './Authors.svelte';

	import { setupI18n, isLocaleLoaded, dir } from './services/i18n';

	$: if (!$isLocaleLoaded) {
        setupI18n({ withLocale: 'lv' });
    }
    $: { document.dir = $dir; }

</script>

<main>
	{#if $isLocaleLoaded}
	 <Navbar />
	 <!-- <Hero /> -->
	 <About />
	 <WhyUs />
	 <Services />
	 <Authors />
	 <Reviews />
	 <Contacts />
	 <Footer />
	 {:else}
    <p>Loading...</p>
{/if}
</main>


<style>

</style>